/*
 * @Author: lisl27
 * @Date: 2021-11-29 15:31:44
 * @LastEditors: lisl27
 * @LastEditTime: 2021-11-30 17:12:09
 * @Description: file content
 */
import { BiddingDetailController } from './biddingDetail';
import { BusinessAddressController } from './businessAddress';
import { BusinessDetailController } from './businessDetail';
import { BusinessInfoController } from './businessInfo';
import { BusinessSplitController } from './businessSplit';
import { CommonController } from './common';
import { HomeController } from './home';
import { PriceQuotationController } from './priceQuotation';
import { PriceQuotationDetailController } from './priceQuotationDetail';
import { BusinessPriceQuotationProductController } from './priceQuotationProduct';
import { BusinessPriceQuotationReviewDetailController } from './priceQuotationReviewDetail';
import { BusinessPriceQuotationReviewListController } from './priceQuotationReviewList';
import { PriceQuotationSplitController } from './priceQuotationSplit';
import { ProductController } from './product';
import { ProductInfoController } from './productInfo';
import { RapidQuotationController } from './rapidQuatation';
import { RapidQuotationAddressController } from './rapidQuotationAddress';
import { RapidQuotationDetailsController } from './rapidQuotationDetails';
import { RapidQuotationProductController } from './rapidQuotationProduct';
import { ReportDetailController } from './reportDetail';
import { SubscriptController } from './subscript';

export class BusinessController {
  constructor() {}
  /** @dec 公用数据 */
  CommonController = new CommonController();
  /** @dec 商机列表 */
  HomeController = new HomeController();
  /** @dec 添加/编辑商机信息 */
  BusinessInfoController = new BusinessInfoController();
  /** @dec 添加/编辑产品信息 */
  ProductInfoController = new ProductInfoController();
  /** @dec 订阅 */
  SubscriptController = new SubscriptController();
  /** @dec 添加产品时产品查询 */
  ProductController = new ProductController();
  /** @dec 商机详情页面 */
  BusinessDetailController = new BusinessDetailController(
    this.CommonController,
  );
  /** @dec 商机报价单列表 */
  BusinessPriceQuotationController = new PriceQuotationController();
  /** @dec 商机报价单详情页 */
  BusinessPriceQuotationDetailController = new PriceQuotationDetailController();
  /** @dec 报价单详情页面 */
  ReportDetailController = new ReportDetailController(this.CommonController);
  /** @dec 转单页面 */
  BusinessSplitController = new BusinessSplitController(this);
  /** @dec 商机报价单转单页面 */
  BusinessPriceQuotationSplitController = new PriceQuotationSplitController(
    this,
  );
  /** @dec 转单收货地址页面 */
  BusinessAddressController = new BusinessAddressController();
  /** @des 报价单审核列表页面 */
  BusinessPriceQuotationReviewListController =
    new BusinessPriceQuotationReviewListController();
  /** @des 报价单审核详情页页面 */
  BusinessPriceQuotationReviewDetailController =
    new BusinessPriceQuotationReviewDetailController();
  /** @des 报价单审核页面产品模块 */
  BusinessPriceQuotationProductController =
    new BusinessPriceQuotationProductController();
  /** @dec Bidding审价单页面 */
  BiddingDetailController = new BiddingDetailController(this.CommonController);
  /** @des 智能报价单列表页 */
  RapidQuotationController = new RapidQuotationController();
  /** @des 智能报价单选择产品页 */
  RapidQuotationProductController = new RapidQuotationProductController();
  /** @des 智能报价单详情页 */
  RapidQuotationDetailsController = new RapidQuotationDetailsController();
  /** @des 智能报价单地址页 */
  RapidQuotationAddressController = new RapidQuotationAddressController();
}
